"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

function useEventStopPropagation(fn) {
  if (!fn) return void 0;
  return function(event) {
    const isClickOnLink = !!event.target.closest("a");
    if (!isClickOnLink) {
      event?.preventDefault?.();
    }
    event?.stopPropagation?.();
    event?.nativeEvent?.stopImmediatePropagation?.();
    if (typeof fn === "function") fn?.(event);
  };
}

export { useEventStopPropagation as default };
